import { render, staticRenderFns } from "./sobreMi.vue?vue&type=template&id=bf50d2b4&"
import script from "./sobreMi.vue?vue&type=script&lang=js&"
export * from "./sobreMi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports